import { render, staticRenderFns } from "./brandSummary2.vue?vue&type=template&id=7539e691&scoped=true&"
import script from "./brandSummary2.vue?vue&type=script&lang=js&"
export * from "./brandSummary2.vue?vue&type=script&lang=js&"
import style0 from "./brandSummary2.vue?vue&type=style&index=0&id=7539e691&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7539e691",
  null
  
)

export default component.exports